import React from "react";
import { useTranslation } from "react-i18next";
import "./whereData.scss";

function WhereData() {
  const { t } = useTranslation()

  return (
    <div className="container-whereData">
      <div className="text-title-whereData">
        <h1>{t("data_management.cloud_or_onpremise.title")}</h1>
      </div>
      <div className="container-cloud-infra">
        <div className="cloud">
          <h1>{t("data_management.cloud_or_onpremise.cloud.title")}</h1>
          <p>{t("data_management.cloud_or_onpremise.cloud.section_text")}</p>
        </div>
        <div className="infra">
          <h1>{t("data_management.cloud_or_onpremise.onpremise.title")}</h1>
          <p>{t("data_management.cloud_or_onpremise.onpremise.section_text")}</p>
        </div>
      </div>
    </div>
  );
}

export default WhereData;
